export const databaseTypeCodes = {
  homeowner() { return "H"; },
  automobile() { return "A"; },
  telephoneHomeowner() { return "I"; },
  mAndC() { return "M"; },
};

export const personOptions = [
  { label: "Agent", value: "AGENT" },
  { label: "Field Representative", value: "FIELD_REPRESENTATIVE" },
  { label: "Mueller Office Staff", value: "MUELLER_OFFICE_STAFF" },
  { label: "Other", value: "OTHER" },
  { label: "Policyholder/Borrower", value: "POLICYHOLDER" },
  { label: "Rep for Policyholder/Borrower (Relative, Lawyer etc.)", value: "REP_FOR_POLICYHOLDER_RELATIVE_LAWYER_ETC" },
  { label: "Underwriter", value: "UNDERWRITER" },
];

export const appraiserReasonOptions = [
  { label: "Data Error", value: "DATA_ERROR" },
  { label: "Sketch", value: "SQUARE_FOOTAGE" },
  { label: "Photo", value: "PHOTO" },
  { label: "Additional Documentation", value: "UPDATE_ORDER_INFO" },
];

export const insuranceReasonOptions = [
  { label: "Appointment", value: "APPOINTMENT" },
  { label: "Closed Out", value: "CLOSED_OUT" },
  { label: "Data Error", value: "DATA_ERROR" },
  { label: "Data Update", value: "DATA_UPDATE" },
  { label: "Escalated Issue", value: "ESCALATED_ISSUE" },
  { label: "Hazard", value: "HAZARD" },
  { label: "Mueller Rep Handling", value: "MUELLER_REP_HANDLING" },
  { label: "Other", value: "OTHER" },
  { label: "Photo", value: "PHOTO" },
  { label: "Request for Copy of Survey", value: "REQUEST_FOR_COPY_OF_SURVEY" },
  { label: "Square Footage", value: "SQUARE_FOOTAGE" },
  { label: "Status Update", value: "STATUS_UPDATE" },
  { label: "Update Order Info", value: "UPDATE_ORDER_INFO" },
];

export const valuationReasonOptions = [
  { label: "Appointment", value: "APPOINTMENT" },
  { label: "Closed Out", value: "CLOSED_OUT" },
  { label: "Data Error", value: "DATA_ERROR" },
  { label: "Data Update", value: "DATA_UPDATE" },
  { label: "Escalated Issue", value: "ESCALATED_ISSUE" },
  { label: "Mueller Rep Handling", value: "MUELLER_REP_HANDLING" },
  { label: "Other", value: "OTHER" },
  { label: "Photo", value: "PHOTO" },
  { label: "Request for Copy of Survey", value: "REQUEST_FOR_COPY_OF_SURVEY" },
  { label: "Revision Request", value: "REVISION_REQUEST" },
  { label: "ROV", value: "ROV" },
  { label: "Square Footage", value: "SQUARE_FOOTAGE" },
  { label: "Status Update", value: "STATUS_UPDATE" },
  { label: "Update Order Info", value: "UPDATE_ORDER_INFO" },
  { label: "Appraisal Complaint", value: "APPRAISAL_COMPLAINT" },
  { label: "Replacement Appraisal", value: "REPLACEMENT_APPRAISAL" },
];

export const errorOptions = [
  { label: "None", value: "4", code: "NONE" },
  { label: "FR Error", value: "2", code: "FR_ERROR" },
  { label: "Call Center Rep Error", value: "1", code: "CALL_CENTER_REP_ERROR" },
  { label: "Field Service QA Error", value: "5", code: "QA_ERROR" },
  { label: "FR/Call Center Rep, QA Error", value: "3", code: "FR_CALL_CENTER_REP_QA_ERROR" },
  { label: "Appraiser Error", value: "6", code: "AP_ERROR" },
  { label: "Appraisal QA Error", value: "7", code: "AP_QA_ERROR" },
  { label: "FS QA Error (Lender)", value: "8", code: "FS_QA_ERROR_LENDER" },
];

export const statusOptions = [
  { label: "Open", value: "OPEN" },
  { label: "Closed", value: "CLOSED" }
];